export default __webpack_public_path__ + "static/default-blog-1891e726501d66b650aec2fde7118df5.jpg";